import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to fetch PDFs
export const fetchPdf = createAsyncThunk("pdf/fetchPdf", async () => {
    const response = await fetch(`https://api.notesmania.in/get_other_pdf.php`);
    const data = await response.json();
    return data;
});

const pdfSlice = createSlice({
    name: 'pdf',
    initialState: {
        pdf: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPdf.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPdf.fulfilled, (state, action) => {
                state.loading = false;
                state.pdf = action.payload;
            })
            .addCase(fetchPdf.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message; // Corrected error handling
            });
    }
});

export default pdfSlice.reducer;
